/**
 * @deprecated
 * Constants string for dataset names used by dark mode
 */
// eslint-disable-next-line etc/no-const-enum
export var DarkModeDatasetNames;
(function (DarkModeDatasetNames) {
    /**
     * Original style text color
     */
    DarkModeDatasetNames["OriginalStyleColor"] = "ogsc";
    /**
     * Original style background color
     */
    DarkModeDatasetNames["OriginalStyleBackgroundColor"] = "ogsb";
    /**
     * Original attribute text color
     */
    DarkModeDatasetNames["OriginalAttributeColor"] = "ogac";
    /**
     * Original attribute background color
     */
    DarkModeDatasetNames["OriginalAttributeBackgroundColor"] = "ogab";
})(DarkModeDatasetNames || (DarkModeDatasetNames = {}));
//# sourceMappingURL=DarkModeDatasetNames.js.map